module.exports = __webpack_public_path__ + "static/media/Firefox.afa1c612.png";